
import { useState, useCallback } from 'react';

const PLACEHOLDER_SVG = 'data:image/svg+xml,' + encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 400 400"><rect fill="#F5F3F0" width="400" height="400"/><g transform="translate(150,140)"><rect x="15" y="0" width="70" height="8" rx="4" fill="#D4CFC8"/><rect x="0" y="20" width="100" height="80" rx="8" fill="#E8E4DF"/><rect x="30" y="45" width="40" height="30" rx="4" fill="#D4CFC8"/><circle cx="65" cy="40" r="8" fill="#D4CFC8"/></g><text x="200" y="260" text-anchor="middle" fill="#B5AFA7" font-family="system-ui" font-size="14">Imagen no disponible</text></svg>'
);

interface ProductImageProps {
  src: string;
  alt: string;
  title?: string;
  className?: string;
}

export default function ProductImage({ src, alt, title, className = '' }: ProductImageProps) {
  const [imgSrc, setImgSrc] = useState(src);
  const [hasError, setHasError] = useState(false);

  const handleError = useCallback(() => {
    if (!hasError) {
      setHasError(true);
      setImgSrc(PLACEHOLDER_SVG);
    }
  }, [hasError]);

  return (
    <img
      src={imgSrc}
      alt={alt}
      title={title || alt}
      className={className}
      onError={handleError}
      loading="lazy"
    />
  );
}
